import { Timestamp } from '../models';

export enum V2_QUERY_TYPES {
  PREVIOUSLY_VIEWED_PRODUCTS = 'qpvp',
  MOST_POPULAR_PRODUCTS = 'qmpp',
  CATEGORY_NAME = 'qcn',
  CUSTOMER_HAS_TAG = 'rctags',
  CONDITION_EVALUATION = 'qce',
  TEMPLATE_EVALUATION = 'qte',
  CURRENT_PAGE_TYPE = 'qcpt',
  GRAPHQL = 'qgql',
  CLIENT_STATE = 'qcs',
  CLIENT_EVENT = 'qci', // client-event-db.ts, backed by indexedDB
}

export interface V2QueryBase {
  type: V2_QUERY_TYPES;
}
